import { isAuthenticated } from '@kdose/ng-auth';
import { ChangePasswordFormComponent } from './change-password-form.component';

export const ROUTES = [
  {
    path: 'passwort-aendern',
    component: ChangePasswordFormComponent,
    canActivate: [isAuthenticated]
  },
];
